<template>
  <div class="system-user-list">
    <div class="page-title bottom-line">
      {{ $t('data.exchange_rate') }}
    </div>
    <div class="filter-container">
      <el-button type="primary" class="search-btn" size="small" @click="getList">{{ $t('components.refresh') }}</el-button>
    </div>
    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column :label="$t('data.base_currency')" align="center">
          <template slot-scope="scope">
            {{ scope.row.base_currency }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.quote_currency')" align="center">
          <template slot-scope="scope">
            {{ scope.row.quote_currency }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.exchange_rate')" width="300"   align="center">
          <template slot-scope="scope">
           <div> {{ scope.row.exchange_rate }}</div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.update_time')"  align="center">
          <template slot-scope="scope">
            {{ scope.row.update_time }}
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin: 10px; color: #1D3A71; font-size:14px">* {{ $t('tips.exchange_rate_update_tip')}}</div>
    </div>
  </div>
</template>

<script>
import { queryForeignExchangeRate } from '@/api/settlement/settlement'

export default {
  name: 'FX_QUERY',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
  },
  data() {
    return {
      search: {
        username: ''
      },
      tableData:  [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      timer: null
    }
  },
  mounted() {
    this.getList()
    // 每3分钟自动刷新一次
    this.timer = setInterval(() => {
      this.getList(false)
    }, 3 * 60 * 1000)
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    onClickPaginator() {
      const params = {
        page: this.listQuery.page
      }
      this.getList(params)
    },
    getParams(otherParams = {}) {
      const { create_time, complete_time = [], ...otherSearch } = this.search
      let params = { ...otherSearch, ...otherParams }
      params = this.$commonFn.filterEmptyAttr(params)
      return params
    },
    getList(otherParams = {}) {
      // 只有手动刷新时才显示loading
      if (otherParams !== false) {
        this.listLoading = true
      }
      const params = this.getParams(otherParams)
      queryForeignExchangeRate(params).then(res => {
        this.tableData = res.data
        // this.listQuery.total = res.data.total
        // this.listQuery.page = params.page ? params.page : 1
      }).finally(() => {
        this.listLoading = false
      })
    }
  }
}
</script>

<style scoped>
  .system-user-list{
    margin: 48px;
    background-color: #fff;
  }
  .filter-container{
    text-align: right;
    padding: 0 24px 24px;
  }
  .search-frame {
    width: 160px;
    margin-left: 5px;
  }
  .search-btn {
    margin-left: 10px;
  }
</style>
